<template>
  <div></div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { PERMISSION_TYPE } from '@/core/plugins/constants';
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from '@/core/services/store/htmlclass.module.js';

// Thứ tự ưu tiên trang redirect sau login
const LANDING_CANDIDATES = [
  { name: 'user_portal_list',       pageCode: 'AccountAccountPortal' },
  { name: 'coach_customers',        pageCode: 'MyCustomer' },
  { name: 'customer_receives_list', pageCode: 'CustomerReceives' },
  { name: 'customer_center_list',   pageCode: 'CustomerCenter' },
  { name: 'active_account_list',    pageCode: 'CustomerGroup' },
  { name: 'user_app_list',          pageCode: 'AccountAccountApp' },
  { name: 'user_dashboard',         pageCode: 'UserDashboard' },
];

export default {
  name: 'dashboard',
  components: {},
  computed: {
    ...mapGetters(['currentUser', 'isAuthenticated']),
    ...mapState({ permissions: (state) => state.auth.permissions || [] }),
  },
  mounted() {
    this.$store.dispatch(ADD_BODY_CLASSNAME, 'page-loading');
    this.$store.dispatch(REMOVE_BODY_CLASSNAME, 'page-loading');
    this.checkAndRedirect();
  },
  watch: {
    permissions() {
      this.checkAndRedirect();
    },
    'currentUser.id': function() {
      this.checkAndRedirect();
    }
  },
  methods: {
    checkAndRedirect() {
      // Đợi load xong permission và user
      if (this.permissions.length === 0 || !this.currentUser || !this.currentUser.id) return;
      this.redirectToFirstAllowed();
    },
    redirectToFirstAllowed() {
      const currentUserId = this.currentUser?.id || this.currentUser?.Id || this.currentUser?.accountId;
      if (currentUserId === 'e46af68d-8602-4933-8e05-d114671c6056') {
        this.$router.push({ name: 'bcb-campaign-detail', params: { id: 'f23b5013-0e7a-4258-a194-08dee0ae483a' } });
        return;
      }

      for (const candidate of LANDING_CANDIDATES) {
        const page = this.permissions.find((p) => p.code === candidate.pageCode);
        const hasView = page?.value?.some((p) => p.nameType === PERMISSION_TYPE.VIEW);
        if (hasView) {
          this.$router.push({ name: candidate.name });
          return;
        }
      }
      this.$toastr.w('Tài khoản chưa được cấp quyền truy cập. Vui lòng liên hệ Admin.', 'Chưa có quyền');
    },
  },
};
</script>
